import { render, staticRenderFns } from "./NoticeVditor.vue?vue&type=template&id=8c141380"
import script from "./NoticeVditor.vue?vue&type=script&lang=js"
export * from "./NoticeVditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports